import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { BottomSheetPageIdProvider } from '../../providers/BottomSheetPageIdProvider';
import { DeviceProvider } from '../../providers/Device';
import { IsInBottomSheetProvider, useIsInBottomSheet } from '../../providers/IsInBottomSheetProvider';
import { useHostInBottomSheet } from '../OverlayContext/hooks/useHostInBottomSheet';
import { useModalHost } from '../OverlayContext/ModalContainer/ModalContainer';
import { OverlayPopupZIndex } from '../OverlayContext/OverlayPopupZIndex/OverlayPopupZIndex';
export function BottomSheet(param) {
    let { open, children, onClose, paddingBottom, height, variant, closeSheetOnLeave, replacesHostSurface } = param;
    const modalHost = useModalHost();
    const isInBottomSheet = useIsInBottomSheet();
    const hidesTheSurfaceItReplaces = replacesHostSurface === true && open && !isInBottomSheet;
    useEffect(()=>{
        if (!hidesTheSurfaceItReplaces) return undefined;
        modalHost.setDetached(true);
        return ()=>modalHost.setDetached(false);
    }, [
        hidesTheSurfaceItReplaces,
        modalHost
    ]);
    const sheetPage = useHostInBottomSheet({
        enabled: open,
        page: {
            paddingBottom,
            height,
            variant
        },
        hideSheetOnLeave: closeSheetOnLeave,
        onRemovedFromStack: onClose
    });
    if (!open || sheetPage == null) return null;
    return /*#__PURE__*/ createPortal(/*#__PURE__*/ _jsx(DeviceProvider, {
        value: {
            isMobileDevice: true
        },
        children: /*#__PURE__*/ _jsx(IsInBottomSheetProvider, {
            value: true,
            children: /*#__PURE__*/ _jsx(OverlayPopupZIndex, {
                hostZIndex: sheetPage.hostZIndex,
                children: /*#__PURE__*/ _jsx(BottomSheetPageIdProvider, {
                    value: sheetPage.pageId,
                    children: children
                })
            })
        })
    }), sheetPage.portalTarget);
}
